import { RegisterOptions } from "react-hook-form";

type AccountDataFormValidationType = {
  [key: string]: RegisterOptions;
};

export const AccountDataFormValidation: AccountDataFormValidationType = {
  name: {
    validate: (value: string) => {
      if (!value) {
        return true;
      }

      if (!/^[ A-Za-z ]*$/.test(value)) {
        return "registration.validator.error";
      }

      return true;
    },
  },
  date: {
    required: "profile.balance.deposit.input.validation.empty",
    minLength: {
      value: 10,
      message: "registration.validator.error",
    },
  },
};
